<template>
  <div class="details_view">
    <span class="title">{{ label }}</span>
    <div class="process_name_bar flex align-center">
      <div class="process_name">
        {{ processName }}
      </div>
      <span class="link flex align-center" @click="handleClick"><img class="link_icon" src="@/assets/Stroke.png">前往设置规则</span>
    </div>
    <div class="content">
      <span class="content_title">规则详情</span>
      <el-row>
        <el-col
          v-for="(item, index) in field"
          :key="item.prop"
          :span="12"
        >
          <div class="content_item flex align-center" :class="{borderRight: index%2 === 0}">
            <div class="flex align-center flex1">
              <span class="item_label flex align-center">{{ item.label }}<span class="colon">:</span></span>
              <span class="item_content">{{ item.formatter?item.formatter(form):form[item.prop] }}</span>
            </div>
            <div v-if="item.unit" class="flex align-center flex1">
              <span class="item_label flex align-center">单位<span class="colon">:</span></span>
              <span class="item_content">{{ item.unit }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { WUJIE_EVENT_NAME } from '@/utils/subWujie/event';

export default {
  name: 'DetailsView',
  props: {
    label: {
      type: String,
      default: '',
    },
    processName: {
      type: String,
      default: '',
    },
    processCode: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
    field: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClick() {
      const routeUrl = this.$router.resolve({
        path: '/configure/processNodeEite',
        query: {
          tabName: 'TRANSPORT_ONLY',
          code: this.processCode,
        },
      });
      if (window.$wujie) {
        window.$wujie.bus.$emit(WUJIE_EVENT_NAME.SUB_ROUTE_CHANGE, {
          path: routeUrl.route.fullPath,
        });
      } else {
        window.open(routeUrl.href, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details_view{
  padding-right: 24px;
  padding-bottom: 24px;
  .title{
    color: #404B5C;
    font-size: 14px;
    margin-bottom: 8px;
    display: inline-block;
  }
  .process_name_bar{
    margin-bottom: 14px;
  }
  .process_name{
    width: 224px;
    height: 30px;
    line-height: 30px;
    background: #F0F2F5;
    border: 1px solid #EBECEE;
    border-radius: 4px;
    color: #B3B7BE;
    padding-left: 12px;
    margin-right: 8px;
    font-size: 14px;
  }
  .link{
    cursor: pointer;
    font-size: 14px;
    color: #1890FF;
    .link_icon{
      margin-right: 8px;
      width: 12px;
      height: 12px;
    }
  }
  .content{
    padding: 8px 24px 0;
    background: #F0F2F5;
    position: relative;
    .content_title{
      color: #404B5C;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
      display: inline-block;
    }
    &::before{
      content:'';
      width: 12px;
      height: 12px;
      display: inline-block;
      background: #F0F2F5;
      transform: rotate(45deg);
      position: absolute;
      top: -6px;
      left: 12px;
    }
    .content_item{
      width: calc(100% - 24px);
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 16px;
      .item_label{
        color: #000F25;
        .colon{
          margin: 0 4px;
        }
      }
      .item_content{
        color: #000F25;
      }
    }
    .borderRight{
      border-right: 1px solid #D9DBDE;
    }
  }
}
</style>
